import React from 'react';
import { useTheme } from '../../Context/ThemeContext';
import { ByteLight, ByteDark } from '../../Assets/Images';
import styles from './phoneFrame.module.scss';

const PhoneFrame: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <div className={styles.phoneFrameContainer}>
      <div className={styles.phoneFrame}>
        <div className={styles.phoneScreen}>
          <img 
            src={theme === 'dark' ? ByteDark : ByteLight} 
            alt="QR Menu Preview" 
            className={styles.previewImage}
          />
        </div>
      </div>
    </div>
  );
};

export default PhoneFrame;
